const STORAGE_KEY = 'temporaryGuestListGuid';

const getStorage = () => (import.meta.client ? window.localStorage : null);

export function storeTemporaryGuestListGuid(listGuid) {
  listGuid && getStorage()?.setItem(STORAGE_KEY, listGuid);
}

export function getTemporaryGuestListGuid() {
  return getStorage()?.getItem(STORAGE_KEY) ?? null;
}

export function isTemporaryGuestListGuidMatch(listGuid) {
  return !!listGuid && getTemporaryGuestListGuid() === listGuid;
}

export function removeTemporaryGuestListGuid() {
  getStorage()?.removeItem(STORAGE_KEY);
}
